import React, { useState } from "react";
import { useDispatch } from "react-redux";
import "./Login.scss";
import { loginAdmin } from "../../redux/services/authService/authApi";
import { setLogin } from "../../redux/features/authSlice";
import { loadingToast, updateToastSuccess, updateToastError, successToast, errorToast } from "../../Utils/toast";
import Slider from "react-slick";
import { FaUsers, FaHandsHelping, FaChalkboardTeacher } from "react-icons/fa";
import { FaUserFriends } from "react-icons/fa";
import { MdOutlineMail, MdLockOutline } from "react-icons/md";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router";
import Cookies from "js-cookie";
import { setToken } from "../../routes/cookies";
import loginimage from '../../assets/image/bgimage.png';
function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      errorToast("Error", "All fields are required");
      return;
    }

    try {
      setLoading(true);
      const toastId = loadingToast("Logging in...");
      
      const response = await loginAdmin({ email, password });
      
      console.log("✅ Login Response:", response);
      
      if (response?.success) {
        // ✅ Get user data from response.data
        const userData = response.data || {};
        
        // ✅ Ensure user object has all fields
        const user = {
          id: userData.id || null,
          name: userData.name || "Admin",
          email: userData.email || email,
          mobile: userData.mobile || null,
          role: userData.role || "admin",          // ✅ Role यहाँ से लो
          waad_id: userData.waad_id || null,       // ✅ Waad_id यहाँ से लो
          waad_name: userData.waad_name || null,
          status: userData.status || 1,
        };
        
        console.log("👤 Final User Object:", user);
        console.log("👤 Final Role:", user.role);
        console.log("📍 Final Waad ID:", user.waad_id);
        
        // ✅ Set token in cookies & localStorage
        if (response.token) {
          setToken(response.token);
          console.log("✅ Token set in cookies & localStorage");
        }
        
        // ✅ SET DATA IN LOCALSTORAGE (बहुत जरूरी)
        localStorage.setItem("userRole", user.role);
        localStorage.setItem("userWaadId", user.waad_id || "");
        localStorage.setItem("userWaadName", user.waad_name || "");
        localStorage.setItem("userData", JSON.stringify(user));
        
        console.log("✅ Role set in localStorage:", localStorage.getItem("userRole"));
        console.log("✅ Waad ID set in localStorage:", localStorage.getItem("userWaadId"));
        
        // ✅ Dispatch login
        dispatch(setLogin({
          user: user,
          token: response.token,
          permissions: response.data?.permissions || [],
        }));
        
        updateToastSuccess(toastId, response.message || "Login Successful");
        
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 500);
        
      } else {
        throw new Error(response?.message || "Login failed");
      }
    } catch (error) {
      console.error("❌ Login Error:", error);
      const errorMsg = error?.response?.data?.message || error?.message || "Login Failed";
      errorToast("Error", errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    fade: true,
  };

  const data = [
    {
      id: 1,
      title: "Bagra Samaj Ka Parichay",
      desc: "Bagra Samaj ki samriddh sanskriti, parampara aur itihaas ko jaaniye aur apni virasat se jude rahiye.",
      image: "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=1400&auto=format&fit=crop",
    },
    {
      id: 2,
      title: "Samajik Karyakram",
      desc: "Bagra Samaj ke vividh samajik, shaikshanik aur sanskritik karyakramon ki jankari prapt karein.",
      image: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?q=80&w=1400&auto=format&fit=crop",
    },
    {
      id: 3,
      title: "Yuva Aur Shiksha",
      desc: "Yuvaon ke vikas, shiksha aur rojgar ke avsaron ko badhava dene ke liye samarpit pahal.",
      image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1400&auto=format&fit=crop",
    },
  ];

  return (
    <section className="login-page">
      <div className="login-wrapper">
        <div className="grid_all left-side">
           <img src={loginimage} alt="Login" />
        </div>

        {/* RIGHT SIDE */}
        <div className="grid_all right-side">
          <div className="login-card">
            <div className="hotel-icon">
              <FaUserFriends />
            </div>

            <div className="login-logo">
              <h2>
                Bagra <span>Samaj</span>
              </h2>
              <p>
                Swagat hai! Kripya apne account mein login karein.
              </p>
            </div>

            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label>Email Address</label>
                <div className="input-box">
                  <span className="input-icon">
                    <MdOutlineMail />
                  </span>
                  <input
                    type="email"
                    value={email}
                    className="form-control"
                    placeholder="Enter your email"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Password</label>
                <div className="input-box">
                  <span className="input-icon">
                    <MdLockOutline />
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    placeholder="Enter your password"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="login-options">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="remember"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="remember"
                  >
                    Remember me
                  </label>
                </div>
                <a href="/" className="forgot-link">
                  Forgot Password?
                </a>
              </div>

              <button
                type="submit"
                className="login-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Signing In...
                  </>
                ) : (
                  "Sign In"
                )}
              </button>
            </form>

            <div className="login-footer">
              <p>
                Don't have an account?
                <a href="/"> Sign Up</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;